import {Image} from '@/_application/core/components/ui/image';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import {authorizationAtom} from '@/store/authorization-atom';
import cn from 'classnames';
import {useAtom} from 'jotai';
import {UserInfoMobile} from '../user-info';
import {KicoinBalanceMobile} from '../kicoin';

const KicoinIcon = getImageAssetUrl('icons/kcoin.png');

export const UserInfoCardMobile = () => {
    const [isAuthorized] = useAtom(authorizationAtom);

    return (
        <div
            className="relative mx-auto flex h-16
      w-[calc(100vw-32px)] items-center rounded-xl bg-white shadow-lg">
            <div className="flex h-[70%] w-full justify-between px-3">
                <div className={cn('flex w-full items-center pr-2')}>
                    <UserInfoMobile />
                </div>
                <div className="h-full w-px bg-KPZ_divider" />
                <div
                    className={cn('flex w-full items-center justify-center pl-1', {
                        'px-4': isAuthorized,
                    })}>
                    <div className="flex h-[80%]">
                        <div className="flex h-9 w-9 items-center justify-center">
                            <Image src={KicoinIcon} alt="profile" width={30} height={30} />
                        </div>

                        {isAuthorized ? (
                            <KicoinBalanceMobile />
                        ) : (
                            <div className="mr-1 flex w-[70%]">
                                <p className="my-auto text-[10px]" style={{lineHeight: 'normal'}}>
                                    Vui lòng đăng nhập để kiểm tra điểm Kicoin
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
